import { render, staticRenderFns } from "./ControlWidgetShape.vue?vue&type=template&id=16de9233&scoped=true"
import script from "./ControlWidgetShape.vue?vue&type=script&lang=js"
export * from "./ControlWidgetShape.vue?vue&type=script&lang=js"
import style0 from "./ControlWidgetShape.vue?vue&type=style&index=0&id=16de9233&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16de9233",
  null
  
)

export default component.exports